export default "__VITE_ASSET__Cop5iXsN__"